{ "closeAria": "Schließen", "historyAria": "Verlauf der Anfragen", "supportTitle": "Support" }
